import React, { useEffect, useState } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers";
import { Search } from "lucide-react";
import { AddCircleOutline, Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const EXCLUDE_UNIT_LABEL = [
  {
    id: 1,
    label: "Item Code",
    value: "itemCode",
  },
  {
    id: 2,
    label: "Item Name",
    value: "itemName",
  },
  {
    id: 3,
    label: "Discount",
    value: "discount",
  },
  {
    id: 4,
    label: "Item New",
    value: "itemNew",
  },
  {
    id: 4,
    label: "Current Percentage",
    value: "currentPercentage",
  },
  {
    id: 5,
    label: "Sale Rate Base On",
    value: "saleRateBaseOn",
  },
  {
    id: 6,
    label: "Percentage(%)",
    value: "percentage",
  },
  {
    id: 7,
    label: "",
    value: "",
  },
];
const buttonData = [
  { id: 1, label: "Item" },
  { id: 2, label: "Sub Category" },
  { id: 3, label: "Category" },
];
export default function MasterContractAdd() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [excludedDepartments, setExcludedDepartments] = useState([]);

  const handleRemoveTableRow = (rowIndex, currentElement, currentState) => {
    currentState(currentElement?.filter((_, index) => index !== rowIndex));
  };

  const handleAddTableRow = (currentElement, currentState, newRowData) => {
    currentState([...currentElement, newRowData]);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>

        <Box component="form" sx={{ width: "100%", pr: "90px", py: "20px" }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              color: '#5D6A82', 
              textTransform: 'none', 
              fontSize: '16px',
              fontWeight: 'bold',
              padding: 0,
              transition: 'none !important',
            }}
            >
              Back
          </Button>
          {/* enter item details */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "20px",
            }}
          >
            <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
              Add Contract Details
            </Typography>
            {/* <IconButton onClick={() => navigate(-1)}>
              <CloseIcon />
            </IconButton> */}
          </Box>
          {/* first box */}

          {/* second box */}

          {/* third box */}
          <Box
            sx={{
              mb: "30px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="contractMaster"
                  label="Contract Master"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Grid container spacing={1}>
                  {/* saleUnit */}
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      name="startDate"
                      label="Start Date"
                      //   onChange={(newValue) =>
                      //     handleChange({
                      //       target: { name: "startDate", value: newValue },
                      //     })
                      //   }
                      slotProps={{
                        textField: { required: true, fullWidth: true },
                      }}
                      sx={{ bgcolor: "white" }}
                    />
                  </Grid>
                  {/* saleQuantity */}
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      name="endDate"
                      label="End Date"
                      //   onChange={(newValue) =>
                      //     handleChange({
                      //       target: { name: "endDate", value: newValue },
                      //     })
                      //   }
                      slotProps={{
                        textField: { required: true, fullWidth: true },
                      }}
                      sx={{ bgcolor: "white" }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="contractApplicationType"
                  label="Contract Application Type"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="status" />}
                  sx={{ height: "57px" }}
                  label="Status"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="status" />}
                  sx={{ height: "57px" }}
                  label="Consider Price difference as waived (discounted) amount"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="status" />}
                  sx={{ height: "57px" }}
                  label="Apply Item Master Tax for Non-Inventory Items in Patient Bill."
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="status" />}
                  sx={{ height: "57px" }}
                  label="Allow to Enter Item/Package Rate from patient bill."
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4} l>
                <FormControlLabel
                  control={<Checkbox name="status" />}
                  sx={{ height: "57px" }}
                  label="Bypass special hours rates"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="status" />}
                  sx={{ height: "57px" }}
                  label="Pay Difference amount on bed-category change."
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="tinNo"
                  label="TIN No."
                  type="number"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="contractRelief"
                  label="Contract Relief"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="billNo"
                  label="Bill No"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              border: "1px solid rgba(223, 232, 239, 1)",
              borderRadius: "8px",
              mb: "30px",
              p: "20px",
            }}
          >
            {/* dynamic button */}
            <Box
              sx={{
                width: "408px",
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "4px",
              }}
            >
              {buttonData.map((btn) => (
                <Button
                  key={btn.id}
                  onClick={() => setActiveTab(btn.id)}
                  sx={{
                    flex: 1,

                    textTransform: "none",
                    fontWeight: activeTab === btn.id ? "bold" : "normal",
                    color: activeTab === btn.id ? "#1565c0" : "#666",
                    borderBottom:
                      activeTab === btn.id ? "2px solid #1565c0" : "none",
                    borderRadius: 0,
                    "&:not(:last-child)": {
                      borderRight: "1px solid #ccc",
                    },
                  }}
                >
                  {btn.label}
                </Button>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                my: "20px",
              }}
            >
              <TextField
                placeholder="Search"
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RadioGroup
                  row
                  aria-labelledby="demo-form-control-label-placement"
                  name="position"
                  defaultValue="differenceRate"
                >
                  <FormControlLabel
                    value="differenceRate"
                    control={<Radio />}
                    label="Difference Rate"
                  />
                  <FormControlLabel
                    value="flatRate"
                    control={<Radio />}
                    label="Flat Rate"
                  />
                </RadioGroup>

                <Button
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    display: "flex",
                    gap: 0.5,
                    minWidth: "150px",
                    borderColor: "rgba(22, 63, 98, 1)",
                    backgroundColor: "white",
                  }}
                >
                  <Typography>Relief on Multiple Surgery</Typography>
                </Button>
              </Box>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {EXCLUDE_UNIT_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excludedDepartments.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {EXCLUDE_UNIT_LABEL?.map((column, columnIndex) => (
                        <TableCell
                          key={`${rowIndex}${columnIndex}`}
                          sx={{ color: "#5D6A82" }}
                        >
                          {columnIndex === EXCLUDE_UNIT_LABEL?.length - 1 ? (
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  excludedDepartments,
                                  setExcludedDepartments
                                )
                              }
                            />
                          ) : column.value === "itemCode" ||
                            column.value === "currentPercentage" ||
                            column.value === "discount" ? (
                            // Display text instead of TextField
                            //   <span>{row[column.value] || "--"}</span>
                            <Typography>{row[column.value] || "--"}</Typography>
                          ) : (
                            <TextField
                              required
                              name={column.value}
                              value={row[column.value] || ""}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={EXCLUDE_UNIT_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          excludedDepartments,
                          setExcludedDepartments,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* save button */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
